import type { ApiServiceReqRes } from '@meego-setting/idl-api/apiMap'

export { RPC, type ApiServiceReqRes } from '@meego-setting/idl-api/apiMap'

export const ISettingApiService = Symbol('ISettingApiService')

// 从 Response 类型中提取 Data 部分
export type ExtractResponseData<T> = T extends { Data: infer D } ? D : T

export interface ISettingApiService {
  request<RPC extends keyof ApiServiceReqRes>(
    apiName: RPC,
    data: ApiServiceReqRes[RPC]['req'],
    requestConfig?: Record<string, any>
  ): Promise<ExtractResponseData<Awaited<ApiServiceReqRes[RPC]['res']>>>;
}

